import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import * as echarts from 'echarts'
import axios from 'axios'
import Moment from 'moment'
import api from './api'
import preventClick from './utils/clickOnceAtime'
import store from './store/index'
import 'element-ui/lib/theme-chalk/index.css'
import "./common/common.css"
// 导入修改本地后的element的datepicker
Vue.use(ElementUI)
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
Vue.prototype.$EventBus = new Vue();
import moment from 'moment';
Vue.prototype.$moment = moment
// Vue.use(VueRouter)
// import 'vue.config.js'
// require("./mock/mock.js")

Vue.use(preventClick)
// 将api挂载到vue的原型上
Vue.prototype.$api = api;
Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts
Vue.prototype.moment = Moment
Vue.config.productionTip = false
import VueAMap from 'vue-amap'
Vue.use(VueAMap)
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德的key
  key: '019a2508d25e390f01e67307d39509dc',
  // 插件集合
  plugin: [
    'AMap.CircleEditor',// 圆形编辑器插件
    "AMap.Geolocation", // 定位控件，用来获取和展示用户主机所在的经纬度位置
    "AMap.Geocoder", // 地理编码与逆地理编码服务，用于地址描述与坐标间的相互转换
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.CitySearch",
    'AMap.Marker',
    'AMap.ToolBar',
    'AMap.MapType', 
  ],
//   plugin: ['AMap.Geolocation', 'AMap.Marker', 'AMap.Geocoder', 'AMap.ToolBar', 'AMap.MapType',   "AMap.Autocomplete",   "AMap.PlaceSearch",
//  "AMap.CitySearch",],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'
});
//高德的安全密钥
window._AMapSecurityConfig = {
  securityJsCode: '526bd2695d0e233f0c388601210b14d9',
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js